import type ColumnMappingProps from '@Features/data-management/types/ColumnMappingProps'

// fallback for /conveyor/field API response
//  in case the API is not available or returns an error

const feedProps: ColumnMappingProps[] = [
  // Kept in step with the conveyor_field seed migration. unique_id was missing
  // here, so whenever this fallback was reached the one field a sync cannot
  // run without could not be mapped at all — and the save was then refused
  // with no way for the user to satisfy it.
  {
    required: true,
    key: 'unique_id',
    text: 'Unique ID',
  },
  {
    required: true,
    key: 'name',
    text: 'Product Name',
  },
  {
    key: 'product_code',
    text: 'Product Code',
  },
  {
    key: 'barcode',
    text: 'Barcode',
  },
  {
    required: true,
    key: 'brand',
    text: 'Brand',
  },
  {
    required: true,
    key: 'category',
    text: 'Category',
  },
  {
    key: 'tags',
    text: 'Tags',
  },
  {
    key: 'cost',
    text: 'Product Cost',
  },
  {
    key: 'additional_cost',
    text: 'Additional Cost',
  },
  {
    key: 'price',
    text: 'Price',
  },
  {
    key: 'mine_url',
    text: 'Your Own URL',
  },
]

export default feedProps
